import { StateReducers }  from 'state/reducers/types/StateReducers'

interface Props {
  state: StateReducers
}

export const getQueryTeamName = ({ state }: Props): string | undefined => {
  return state.currentLocation?.query?.teamName
}
